import { useRefetchQuery } from "libs/reactQuery";
import { SocketsContext } from "libs/soket";
import { useContext, useEffect, useState } from "react";

import { RefundsCountEventData } from "../siteBarCounters.types";

export const useRefundsCounter = () => {
  const { refundsSocket } = useContext(SocketsContext);
  const [refundsCount, setRefundsCount] = useState<number>(0);
  const refetchRefunds = useRefetchQuery(["refunds"]);

  useEffect(() => {
    if (refundsSocket.socket) {
      refundsSocket.socket?.on(
        "unrefunded-refunds-count",
        (data: RefundsCountEventData) => {
          if (data.totalCount) {
            setRefundsCount(data.totalCount);
          }
          if (data.countChange === "Incremented") {
            setRefundsCount((prev) => prev + 1);
            refetchRefunds();
          }
          if (data.countChange === "Decremented") {
            setRefundsCount((prev) => prev - 1);
            refetchRefunds();
          }
        }
      );
    }

    return () => {
      refundsSocket?.socket?.off("unrefunded-refunds-count");
    };
  }, [refundsSocket.socket]);

  return { refundsCount };
};
